import { Component, AfterViewInit, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import moment = require('moment');
import * as moment from 'moment';
import { WizardService } from '../wizard.service';
// import * as moment from 'moment-timezone';
import { FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { GoogleAuthService, GoogleApiService } from 'ng-gapi';
import { Router } from '@angular/router';
import { convertInjectableProviderToFactory } from '@angular/core/src/di/injectable';

@Component({
  selector: 'app-timezone',
  templateUrl: './timezone.component.html',
  styleUrls: ['./timezone.component.css']
})
export class TimezoneComponent implements OnInit {
  model: any = {};
  public showwizard = false
  public isdialer;
  public disabled: boolean = false
  public checked: boolean = false
  public issmtp;
  public istimezone;
  public divhide: boolean = true
  public divshow: boolean = false
  public tz: boolean = true;
  public dial: boolean = true;
  public smtp: boolean = true;
  public glog: boolean = true;
  isSubmitBtnDisabled: boolean = true;
  isSubmittimezone: boolean = true;
  public selctdialer: any[] = []
  public dialer: any;
  public dialerselection = [];
  myModel: true;
  // model.insuranceDialer: true
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  form: FormGroup;
  dialerArray: FormArray
  public dialerop: any[]
  // checked: true;
  public timezones: any
  arrcheckbox: any[] = []
  checkbox: any[] = []


  selected = 'option2';
  isLinear = true;
  formNameGroup: FormGroup;
  formPasswordGroup: FormGroup;
  formEmailGroup: FormGroup;
  formPhoneGroup: FormGroup;
  public smtpd: any
  curstatus: number;
  Dialers: any = [0, 0, 0, 0]
  isO: boolean = false
  public len: any
  public camp;
  smtpdata: any;
  dialerlenght: any;

  constructor(@Inject(MAT_DIALOG_DATA) protected datas: any, public dialogref: MatDialogRef<TimezoneComponent>, private fb: FormBuilder, public data: WizardService, private gapiService: GoogleApiService, protected router: Router, protected msg: MatSnackBar) {

    this.dialogref.disableClose = true;
    const controls = this.dialerselection.map(c => new FormControl(false));

    this.createForm();
    const localDate = moment();
    const utcDate = moment.utc();
    console.log("Local time:", localDate.format("YYYY-MM-DD HH:mm:ss"));
    console.log("UTC time:", utcDate.format("YYYY-MM-DD HH:mm:ss"));

    this.gapiService.onLoad().subscribe();
  }

  ngOnInit() {
    console.log("datas::", this.datas)
    this.data.getService("getusersdetail").subscribe(res => {
      console.log("userdetail::", res)


      this.model.timezone = res[0].timezone
      if (this.model.timezone != "") {
        this.isSubmittimezone = false
      }

      // dialer's list
      this.data.getService("dialer").subscribe(resd => {
        console.log(resd)
        let tmp = [];
        this.dialerselection = resd;
        console.log("dialer:::::::", this.dialerselection);
        let dialer = res[0].campaign.split(",");
        this.dialerlenght = dialer.length
        console.log("dialessssssssssssss", dialer)
        this.dialerselection.forEach((ele: any) => {
          console.log(ele.id + "==")
          for (let i = 0; i < dialer.length; i++) {
            console.log(dialer[i] +"=="+ ele.id)
             if (dialer[i] == ele.id) {
              console.log(dialer[i] +"=="+ ele.id)              
              console.log("matched", i)
              //[ele.id] = [ele.id];
              this.arrcheckbox.push(dialer[i])
              ele['checked'] = true
              ele['disabled'] = false
            }  
            if(ele.id > dialer[i])
            {
              ele['disabled'] = true
              
            }      
          }
        })
        console.log(this.dialerselection)
        this.form = this.fb.group(tmp);
      })
    })

    // timezone's list
    this.data.getService("wizard").subscribe(res => {
      this.timezones = res
      console.log("timezonedata::::::::;", res);
    })


  }

  createForm() {
    this.form = this.fb.group({
      timezone: ['', Validators.required]
    });
  }

  submitDialer(model) {
    // if (model.lifeDialer == true || model.recruitingDialer == true || model.insuranceDialer == true) {
    this.data.updateUser({ dialerselectiondata: model, isdialer: "isdialer" }).subscribe(res => {
      console.log("isdialerworking", res)
      this.dialogref.close(res);
    })
    // }
  }

  getsmtpdata(event: any) {
    if (event !== null && event !== undefined) {
      console.log('event s', event);
      this.smtpd = event
    }
  }

  geteditorscript(event: any) {
    console.log("event")
    console.log(event)
    if (event !== null && event !== undefined) {
      console.log('event s', event);
      this.smtpd = event
      this.isSubmitBtnDisabled = false;
    }
  }

  wizardConfig(event: any) {
    console.log('dee')
    if (event == 'istimezone')
      event = { skiptimezone: "skiptimezone" }
    this.data.updateUser(event).subscribe(res => {
      console.log("timezone", res)
      // this.dialogref.close(res);
    })
  }

  onSelection(e) {
    this.isSubmittimezone = false;
    console.log(this.isSubmittimezone, 'ddddd', e)
  }

  timezonesget(m: any) {
    if (m != "") {
      this.data.updateUser({ timedata: m, istimezone: "istimezone" }).subscribe(res => {
        console.log("timezone", res)
        this.msg.open("Timezone Selection Done Successfully", "clear", {
          duration: 2000,
        });
        this.dialogref.close();
      })
    }
  }

  googleLoginnext() {
    this.dialogref.close('hiii');
    this.data.updateUser("isgooglelogin").subscribe(res => {
      console.log("google login", res)
    })
  }

  skipgooglelogin() {
    this.dialogref.close('hiii');
  }
  skiptimezone() {
    this.dialogref.close('hiii');
  }

  submit() {
    console.log(this.arrcheckbox, "arrcheck");
    if (this.arrcheckbox.length > 0) {
      this.data.updateUser({ dialer: this.arrcheckbox, isdialer: "isdialer" }).subscribe(res => {
        console.log("timezone", res)
        sessionStorage.setItem("allcampaign", JSON.stringify(res.allcamp))
        // this.msg.open("Dialer selction completed successfully", "Clear");
        this.msg.open("Dialer selction completed successfully", "clear", {
          duration: 2000,
        });
        // this.dialogref.close(res);
      })
    }
  }



  checkdata(event: any, e: any, index: any): any {
    console.log("event value:", event.target.value)
    console.log("checked::", event.currentTarget.checked)
    let id_dialer: any = parseInt(event.target.value)
    let crindex
    let checked: any = event.currentTarget.checked
    if (checked == true) {
      this.arrcheckbox.push(id_dialer)
      console.log(this.arrcheckbox.length)
      if (this.arrcheckbox.length >= this.dialerlenght) {
        this.dialerselection.forEach((ele: any) => {
          crindex = this.arrcheckbox.findIndex(function (ele2: any) {
            return ele.id == ele2
          })
          console.log("curindex:: ", crindex)
          if (crindex == -1) {
            ele.disabled = true
            // console.log("arr",arr)
            console.log("newarray", this.arrcheckbox)
          }
        })
        this.isO = true
      } else {
        this.isO = false
      }
    } else {
      this.dialerselection.forEach((ele: any) => {
        ele.disabled = false
      })
      let crindex = this.arrcheckbox.findIndex(function (ele, i) {
        //  this.dialerselection[index].disabled=true
        return ele.id == id_dialer
      })
      console.log(crindex)
      this.arrcheckbox.splice(crindex, 1)
    }
    console.log("this.arrcheckbox::", this.arrcheckbox)
    console.log(this.dialerselection)
  }

  submitsmtp() {
    console.log("smsmtp")
    this.smtpd;
    console.log(this.smtpd)
    let cdata = this.smtpd.cdata;
    let keyfield = this.smtpd.keyfield
    if (keyfield == -1) {
      this.data.saveService(JSON.stringify(cdata)).subscribe(rs => {
        this.msg.open("Data is added successfully", "clear", {
          duration: 2000,
        });
        this.data.getService().subscribe(rss => {
          console.log(rss);
          keyfield = rss[0].id;
        });
      });
    }
    else {
      this.data.updateService(JSON.stringify(cdata), keyfield).subscribe(rs => {
        this.msg.open("Data is added successfully", "clear", {
          duration: 2000,
        });
      });
    }
  }
}
